module.exports = __webpack_public_path__ + "static/scale-model-of-des-moines'-downtown-farmers’-market-in-des-moines-iowa-eb92fab665d12264b3878c34185929a7.png";